import React from 'react'
import { connect } from 'react-redux'
import * as selfActions from './actions'
import * as appActions from '@/containers/App/actions'
import List from '@/components/List'
import * as selfConstants from './constants'
import { bindActionCreators } from 'redux'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import Button from '@/components/Button'
import {
  HighlightText,
  LinkButton,
  SummaryWrapper,
  HorizontalLine,
  LayoutBottom
} from './components/styledComponents'
import MoreInfoContent from './components/MoreInfoContent'
import * as helpers from '@/utils/helpers'
import failureSmiley from '../2/failure-smiley.svg'
import { UploadFailureText } from '../2/styledComponents'
import { toIndonesiaCurrency } from '../../App/utils'
import { Summary } from '@/containers/Steps/4/components/Summary'
import Card from '@/components/Card'

export class Step4 extends React.Component {
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    const { selfActions, intl } = this.props
    console.log('viewdidmount ')
    selfActions.getProducts(intl)
    helpers.getLatLng()
  }

  gotoGetProduct = () => {
    const { selfActions, intl } = this.props
    selfActions.getProducts(intl)
  }

  handleOnTenureChange = (newOptionValue, index) => {
    const { selfActions } = this.props
    window.cdcm.product_id = String(index + 1)
    selfActions.updateSelectedProductId(newOptionValue)
    selfActions.getInstallments()
  }

  handleOnCreditAmountChange = newValue => {
    const { selfActions } = this.props
    selfActions.updateCurrentCreditAmount(newValue)
    this.debouncedGAUpdateCurrentSliderValue(newValue)
  }

  handleMoreInfoClicked = () => {
    const { appActions } = this.props
    appActions.updateModal({
      show: true,
      showHeader: false,
      body: <MoreInfoContent/>
    })
  }

  handleProceed = () => {
    const {
      selfActions,
      currency,
      principal,
      loan_product_id,
      cycle_day
    } = this.props
    selfActions.postProductSelection(
      currency,
      principal,
      loan_product_id,
      cycle_day
    )
    // selfActions.gotoNextStep()
  }
  handleReject = () => {
    const { selfActions } = this.props
    selfActions.logTransaction('LOAN_OFFER_CANCELLED')
    window.location.replace('https://trustiq.id/')
  }

  render () {
    const {
      status,
      creditAmount,
      tenor,
      selectedProduct,
      interestRate,
      interestAmount,
      interestSchedule,
      principalLoan,
      dueDate,
      adminFee,
      disbursementTotal,
      insuranceFee,
      installment,
      product,
      angsuran,
      provisiFee,
      notarisFee,
      materaiFee,
      admTabFee,
      otherFee,
      totalDisburse,
      nominalTabunganWajib,
      lainFee
    } = this.props
    if (status == undefined) {
      console.log('undefined')
      return <div/>
    } else {
      switch (status) {
        default:
          return (
            <div className="d-flex flex-column align-items-center w-100">
              <div className="title w-100 mb-3">
                <FormattedMessage id="step4.label.selectCreditAmount"/>
              </div>
              <SummaryWrapper>
                <Summary
                  label="Jumlah Pinjaman"
                  value={toIndonesiaCurrency(creditAmount)}
                  icon={<i class="bi bi-cash-stack"></i>}
                />
                <Summary
                  label="Produk"
                  value={selectedProduct}
                  icon={<i class="bi bi-file-earmark"></i>}
                />
                <Summary
                  label="Jangka Waktu"
                  value={tenor + ' Bulan'}
                  icon={<i class="bi bi-clock-history"></i>}
                />
                <Summary
                  label={'Bunga Per ' + interestSchedule}
                  value={interestRate}
                  icon={<i class="bi bi-percent"></i>}
                />
              </SummaryWrapper>
              <Card className="w-100 mt-4 py-0">
                <List
                  data={[
                    {
                      key: <span className="text-black-50">Pokok Pinjaman</span>,
                      value: (
                        <b>
                          {typeof principalLoan !== 'undefined' &&
                          principalLoan !== null
                            ? toIndonesiaCurrency(principalLoan)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Admin</span>,
                      value: (
                        <b>
                          {typeof adminFee !== 'undefined' && adminFee !== null
                            ? toIndonesiaCurrency(adminFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Provisi</span>,
                      value: (
                        <b>
                          {typeof provisiFee !== 'undefined' &&
                          provisiFee !== null
                            ? toIndonesiaCurrency(provisiFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Premi</span>,
                      value: (
                        <b>
                          {typeof insuranceFee !== 'undefined' &&
                          insuranceFee !== null
                            ? toIndonesiaCurrency(insuranceFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Notaris</span>,
                      value: (
                        <b>
                          {typeof notarisFee !== 'undefined' &&
                          notarisFee !== null
                            ? toIndonesiaCurrency(notarisFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Materai</span>,
                      value: (
                        <b>
                          {typeof materaiFee !== 'undefined' &&
                          materaiFee !== null
                            ? toIndonesiaCurrency(materaiFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Admin Tabungan</span>,
                      value: (
                        <b>
                          {typeof admTabFee !== 'undefined' &&
                          admTabFee !== null
                            ? toIndonesiaCurrency(admTabFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Biaya Lain Lain</span>,
                      value: (
                        <b>
                          {typeof lainFee !== 'undefined' &&
                          lainFee !== null
                            ? toIndonesiaCurrency(lainFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Tabungan Cash Coll</span>,
                      value: (
                        <b>
                          {typeof otherFee !== 'undefined' && otherFee !== null
                            ? toIndonesiaCurrency(otherFee)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Total Pencairan</span>,
                      value: (
                        <b>
                          {typeof totalDisburse !== 'undefined' &&
                          totalDisburse !== null
                            ? toIndonesiaCurrency(totalDisburse)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Angsuran</span>,
                      value: (
                        <b>
                          {product.graceoninterest === 0 &&
                          product.graceonprincipal === 0
                            ? typeof installment !== 'undefined' &&
                            installment !== null
                              ? toIndonesiaCurrency(installment)
                              : ''
                            : 'Berdasarkan tabel angsuran di bawah ini.'}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Bunga</span>,
                      value: (
                        <b>
                          {typeof interestAmount !== 'undefined' &&
                          interestAmount !== null
                            ? toIndonesiaCurrency(interestAmount)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Nominal Tabungan Wajib</span>,
                      value: (
                        <b>
                          {typeof nominalTabunganWajib !== 'undefined' &&
                          nominalTabunganWajib !== null
                            ? toIndonesiaCurrency(nominalTabunganWajib)
                            : ''}
                        </b>
                      )
                    },
                    {
                      key: <span className="text-black-50">Total Angsuran</span>,
                      value: (
                        <b>
                          {typeof nominalTabunganWajib !== 'undefined' &&
                          nominalTabunganWajib !== null
                            ? toIndonesiaCurrency(
                              installment + nominalTabunganWajib
                            )
                            : ''}
                        </b>
                      )
                    }
                  ]}
                />
              </Card>

              <h5 className="title w-100 mt-4">Tabel Angsuran</h5>
              <div className="table-responsive w-100 mt-2 bg-white" style={{ marginBottom: '70px' }}>
                <table className="table table-bordered m-0">
                  <thead>
                  <tr className="bg-light text-black-50">
                    <th scope="col">Angsuran</th>
                    <th scope="col">Tgl. Jatuh Tempo</th>
                    <th scope="col">Pokok</th>
                    <th scope="col">Bunga</th>
                    <th scope="col">Nilai Angsuran</th>
                  </tr>
                  </thead>
                  <tbody>
                  {angsuran.length ? (
                    angsuran.map(item => (
                      <tr>
                        <td>{item.period || '-'}</td>
                        <td>{item.dueDate || '-'}</td>
                        <td>
                          {toIndonesiaCurrency(item.principalDue || 0)}
                        </td>
                        <td>
                          {toIndonesiaCurrency(item.interestDue || 0)}
                        </td>
                        <td>
                          {toIndonesiaCurrency(
                            item.totalInstallmentAmountForPeriod || 0
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
              <div>
                <LayoutBottom>
                  <Button
                    data-test-id="btn-proceed"
                    disabled={false}
                    onClick={this.handleReject}
                    style={{ minWidth: '40%', backgroundColor: '#FF4E61', borderRadius: '50rem' }}
                  >
                    Batal
                  </Button>
                  {/* <Button
                    disabled={false}
                    onClick={this.handleProceed}
                    style={{
                      marginLeft: '1rem',
                      minWidth: '40%',
                      backgroundColor: '#00BFFE',
                      borderRadius: '50rem'
                    }}
                  >
                    Konfirmasi
                  </Button> */}
                  <Button
                    disabled={this.props.isSubmitting} // Akan true saat proses POST berjalan
                    onClick={this.handleProceed}
                    style={{
                      marginLeft: '1rem',
                      minWidth: '40%',
                      backgroundColor: this.props.isSubmitting ? '#cccccc' : '#00BFFE', // Berubah abu-abu saat loading
                      borderRadius: '50rem',
                      cursor: this.props.isSubmitting ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {this.props.isSubmitting ? 'Mohon Tunggu...' : 'Konfirmasi'}
                  </Button>
                </LayoutBottom>
              </div>
            </div>
          )
        case selfConstants.ON_GET_PRODUCT_FAILED:
          return (
            <React.Fragment>
              <div className="mt-4">
                <img src={failureSmiley}/>
              </div>
              <div className="subtitle text-center mt-2 font-weight-bold">
                <UploadFailureText>
                  <FormattedMessage id="step2.subtitlefailureapology"/>
                </UploadFailureText>
                <UploadFailureText>
                  <FormattedMessage id="step3.subtitlefailurereason"/>
                </UploadFailureText>
              </div>
              <div className="mt-4">
                <span className="subtitle">
                  <FormattedMessage id="step3.label.help"/>
                </span>
              </div>
              <div className="mt-4">
                <Button disabled={false} onClick={this.gotoGetProduct}>
                  <FormattedMessage id="step2.btn.tryagain"/>
                </Button>
              </div>
            </React.Fragment>
          )
      }
    }
  }
}

export const mapStateToProps = state => {
  return {
    status: state.step4.status,
    locale: state.app.locale,
    isSubmitting: state.step4.isSubmitting,
    creditAmount: state.step4.creditAmount,
    tenor: state.step4.tenor,
    selectedProduct: state.step4.selectedProduct,
    interestRate: state.step4.interestRate,
    interestAmount: state.step4.interestAmount,
    interestSchedule: state.step4.interestSchedule,
    dueDate: state.step4.dueDate,
    principalLoan: state.step4.principalLoan,
    adminFee: state.step4.adminFee,
    insuranceFee: state.step4.insuranceFee,
    disbursementTotal: state.step4.disbursementTotal,
    selectedProductId: state.step4.selectedProductId,
    installment: state.step4.installment,
    currency: state.step4.currency,
    principal: state.step4.principal,
    loan_product_id: state.step4.loan_product_id,
    cycle_day: state.step4.cycle_day,
    isMonthlyInstallmentCalculated: state.step4.isMonthlyInstallmentCalculated,
    product: state.step4.product,
    angsuran: state.step4.angsuran,
    provisiFee: state.step4.provisiFee,
    notarisFee: state.step4.notarisFee,
    materaiFee: state.step4.materaiFee,
    admTabFee: state.step4.admTabFee,
    otherFee: state.step4.otherFee,
    totalDisburse: state.step4.totalDisburse,
    nominalTabunganWajib: state.step4.nominalTabunganWajib,
    lainFee: state.step4.lainFee
  }
}

export const mapDispatchToProps = dispatch => {
  return {
    selfActions: bindActionCreators(selfActions, dispatch),
    appActions: bindActionCreators(appActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Step4))
